import React, { FC }            from 'react';
import { SemanticUIColor }      from '../../../../types';
import { AUDIT_RECORD_ACTIONS } from '../../../../constants/SystemRecordEnums';

interface Props {
	
	action: AUDIT_RECORD_ACTIONS,
	label?: string,
}

const defaultProps: Props = {
	action: AUDIT_RECORD_ACTIONS.CHANGE,
	label:  null,
}

const AuditRecordActionText: FC<Props> = React.memo<Props>( ( props ) => {
	
	let actions = {
		[ AUDIT_RECORD_ACTIONS.ADD ]:    { color: SemanticUIColor.GREEN, label: 'added' },
		[ AUDIT_RECORD_ACTIONS.CHANGE ]: { color: SemanticUIColor.ORANGE, label: 'updated' },
		[ AUDIT_RECORD_ACTIONS.REMOVE ]: { color: SemanticUIColor.RED, label: 'removed' },
	}
	
	let action = actions[ props.action ] ?? null;
	
	return action ? (
		<span className={ `text--colored-${ action.color }` }>
			{ props.label ?? action.label }
		</span>
	) : null;
} );

AuditRecordActionText.defaultProps = defaultProps;

export { AuditRecordActionText }
